import React from "react";

import Paper from "@material-ui/core/Paper";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const Loader = ({ open }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <Paper elevation={3} style={{ backgroundColor: "#fff", padding: 50 }}>
        <CircularProgress color="inherit" />
      </Paper>
    </Backdrop>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js